import { Component, ElementRef, ViewChild } from '@angular/core';
import { NavController, IonicPage } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs-compat';
import { map } from 'rxjs-compat/operators/map';
import { AuthProvider } from '../../providers/auth/auth';
import 'rxjs/add/operator/toPromise';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import { AngularFireDatabase } from 'angularfire2/database';

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  @ViewChild('myInput') myInput: ElementRef;
  private snapshotChangesSubscription: any;

  commands =[{
    code: `body {
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      }`,
    tags: 'ionic, node'
  }];

  codes;
  myCode;
  star_given='star_empty';
  star = false;
  items: Array<any>;

  constructor(private afs: AngularFirestore, public navCtrl: NavController) {
    this.getCodes();
  }



  resize() {

    this.myInput.nativeElement.style.height = this.myInput.nativeElement.scrollHeight + 'px';
}

goToLogin(){
  this.navCtrl.push('LoginPage');
}
goToRegister(){
  this.navCtrl.push('RegisterPage');
}

send(ev){
  if( ev.keyCode === 13&&ev.ctrlKey === true){
    // console.log('enterd');
    //deal with send
    var encodedCode = encodeURIComponent(this.myCode)
    this.myCode='';
    return new Promise<any>((resolve, reject) => {
      let currentUser = firebase.auth().currentUser;
      this.afs.collection('people').doc(currentUser.uid).collection('codes').add({
        code: encodedCode
      })
      .then(
        res => resolve(res),
        err => reject(err)
      )
    })

  }

  // console.log(ev)
}

getCodes(){
  return new Promise<any>((resolve, reject) => {
    let currentUser = firebase.auth().currentUser;
    console.log('currentUser',currentUser)
    this.snapshotChangesSubscription = this.afs.collection('people').doc(currentUser.uid).collection('codes').snapshotChanges()
    .subscribe(snapshots => {
      console.log('snapshots',snapshots)
      this.items=snapshots;
      resolve(snapshots);
    })
    // this.snapshotChangesSubscription = this.afs.collection('people').doc(currentUser.uid).collection('tasks').snapshotChanges()
    // .subscribe(snapshots => {
    //   resolve(snapshots);
    // })
  });
}

show(){



  // var a = this.db2.list(`/chats`)
  // .snapshotChanges()
  // .pipe(map(items => {            // <== new way of chaining
  //   return items.map(a => {
  //     // console.log('a inside',a)
  //     const data = a.payload.val();
  //     return data;           // or {key, ...data} in case data is Obj
  //   });
  // }));
  // // this.items = db.collection('items').valueChanges();
  // a.subscribe(res=>{
  //   // this.myCode=res;
  //   console.log('a',res);
  // })
}

createCode(value){

}

giveStar(){
  this.star_given='star_given'
  this.star = false;
}
unGiveStar(){
  this.star_given='star_empty'
  this.star = true;
}

// revealElementHTML(el) {
//   var html = el.innerHTML;
//   el.innerHTML = "";
//   el.appendChild(window.document.createTextNode(html));
// }

ionViewDidLoad(){
  // this.revealElementHTML(window.document.getElementById("myHTML"));

}


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts